import * as types from './../actionTypes';
import PrivateAPIResource from "../../services/PrivateAPIResource";
import ReactSelectFormatter from '../../services/ReactSelectFormatter';

export function loadMachineCategoriesSuccess(machineCategories) {
    return {type: types.LOAD_MACHINE_CATEGORIES_SUCCESS, machineCategories};
}

export function loadCategories(portalId) {
    return function (dispatch) {
        return PrivateAPIResource.all('machine-categories?portalId=' + portalId)
            .then(machineCategories => {
                dispatch(loadMachineCategoriesSuccess(machineCategories))
            });
    }
}


// WEBPACK FOOTER //
// ./web/src/actions/machines/machineCategoriesActions.js